
export function getValueCluster(): any {
    return {
        '81': {
            name: 'Bäcker',
            ma_val1: 10,
            ma_val2: 50,
            um_val1: 500000,
            um_val2: 1000000,
            xt1_val1: 15,
            xt1_val2: 30,
            xt1_key: 'back_flaeche',
            xt2_val1: 50,
            xt2_val2: 300,
            xt2_key: 'mehl_verbrauch',
        },
        '83': {
            name: 'Fleischer',
            ma_val1: 6,
            ma_val2: 15,
            um_val1: 500000,
            um_val2: 1000000,
            xt1_val1: 200,
            xt1_val2: 400,
            xt1_key: 'prod_flaeche',
            xt2_val1: 50,
            xt2_val2: 100,
            xt2_key: 'fleisch_verbrauch',
        },
        '89': {
            name: 'Friseure',
            ma_val1: 6,
            ma_val2: 15,
            um_val1: 150000,
            um_val2: 200000,
            xt1_val1: 200,
            xt1_val2: 300,
            xt1_key: 'flaeche',
        },
        '79': {
            name: 'Kraftfahrzeugtechniker',
            ma_val1: 6,
            ma_val2: 15,
            um_val1: 1000000,
            um_val2: 2500000,
            xt1_val1: 1000,
            xt1_val2: 1500,
            xt1_key: 'flaeche',
        },
        '22': {
            name: 'Tischler',
            ma_val1: 6,
            ma_val2: 15,
            um_val1: 500000,
            um_val2: 1000000,
            xt1_val1: 1000,
            xt1_val2: 1500,
            xt1_key: 'flaeche',
        },
        '32': {
            name: 'Metallbauer',
            ma_val1: 6,
            ma_val2: 15,
            um_val1: 1500000,
            um_val2: 5000000,
        },
        '112': {
            name: 'Textilreiniger',
            ma_val1: 6,
            ma_val2: 15,
            um_val1: 500000,
            um_val2: 1000000,
        },
        'default': {
            name: 'Textilreiniger',
            ma_val1: 6,
            ma_val2: 15,
            um_val1: 500000,
            um_val2: 2500000,
        }
    };

}
